import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiGet } from '../../lib/api';

interface Item {
  id: string;
  title: string;
  body: string | null;
  published_at: string | null;
}

/** 資訊／最新動向（tab 2）—— 讀已發佈內容（由 admin 管理台維護） */
export default function NewsPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState<Item[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    void apiGet<{ items: Item[] }>('/api/content/news').then((r) => {
      if (r.ok && r.data) setItems(r.data.items);
      setLoaded(true);
    });
  }, []);

  return (
    <div className="max-w-md mx-auto">
      <h2 className="text-lg font-bold mb-3">{t('tab.news')}</h2>
      {loaded && items.length === 0 && <p style={{ color: 'var(--color-text-secondary)' }}>{t('empty_none')}</p>}
      <div className="grid gap-3">
        {items.map((n) => (
          <article key={n.id} className="rounded-xl p-4" style={{ background: 'var(--color-card)', boxShadow: 'var(--shadow-card)' }}>
            <div className="flex items-baseline justify-between gap-2">
              <h3 className="font-bold">{n.title}</h3>
              {n.published_at ? (
                <span className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
                  {n.published_at.slice(0, 10)}
                </span>
              ) : null}
            </div>
            {n.body ? (
              <p className="text-sm mt-1" style={{ color: 'var(--color-text-secondary)', whiteSpace: 'pre-wrap' }}>
                {n.body}
              </p>
            ) : null}
          </article>
        ))}
      </div>
    </div>
  );
}

